import Immutable from 'immutable';

const AcademicInfoSummaryRecord = Immutable.Record({
  groupId: undefined,
  studentNumberWithLowerPTScore: undefined,
  studentNumberWithLowerSkillScore: undefined,
  progressTestAverageScore: undefined,
});

export default class AcademicInfoSummary extends AcademicInfoSummaryRecord { }



// WEBPACK FOOTER //
// ./data/AcademicInfo/Summary/model.js